<template>
	<div class="elBreadcrumb english">
		<el-breadcrumb separator=">">
			<el-breadcrumb-item v-for="(item, index) in pathList" :key="index" v-if="item.meta.title">
				<a class="unClick" v-if="~['/PlayStay','/Culture','/TravelInfo'].indexOf(item.path)">{{ item.meta.title }}</a>
				<a :href="context + item.path" v-else>{{ item.meta.title }}</a>
			</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>
<script>
	import '../less/en_pageNav.css'
	export default {
		name: 'EnPageNavigater',
		data() {
			return {
				pathList: [],
				context: '/new'
			}
		},
		mounted() {
			this.pathList = this.getPathList();
		},
		methods: {
			getPathList() {
				if (this.$route.path === '') {
					return []
				}
				const route = this.$router.getRoutes().find(a => a.path === this.$route.path);
				const pathList = [];
				const putTogether = data => {
					pathList.unshift({
						path: data.path,
						meta: data.meta
					});
					if (data.parent && data.parent.path !== '/englishIndex') {
						putTogether(data.parent);
					}
				}
				putTogether(route);
				pathList.unshift({
					path: '/englishIndex',
					meta: {
						title: 'Home'
					}
				});
				const length = pathList.length;
				if (length > 1 && pathList[length - 1].path.endsWith('/info')) {
					if (localStorage.getItem('article_pid')) {
						pathList.splice(length - 1, 0, {
							path: pathList[length - 2].path + '?defTabId=' + localStorage.getItem('article_pid'),
							meta: {
								title: localStorage.getItem('article_pname')
							}
						})
					}
				}
				return pathList;
			}
		}
	}
</script>
<style>
	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		cursor: pointer;
	}
	.el-breadcrumb__item a.unClick {
		cursor: default;
	}
	.el-breadcrumb__item a.unClick:hover {
		text-decoration: unset;
	}
	.el-breadcrumb__item:last-child a {
		color: #800e18 !important;
		font-weight: bold !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/entemplate/en_PageNavigater.vue